// import 依赖类库
import Vue from 'vue'
import VueRouter from 'vue-router'

import ElementUI from 'element-ui'
// 字符串处理类库
import voca from 'voca';
// import 路由表
import routes from './routes';

import store from './store'

// import APP 初始页
import App from './App.vue'

// import ras from '@/api/ras'

// css
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import '@/assets/icons' // icon
import '@/assets/css/index.scss' // global css
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import '@/assets/css/all.css'

import '@/utils/xdate'

import miniBTCTitle from  '@/utils/miniBTC'
Vue.prototype.titleList = miniBTCTitle

Vue.use(ElementUI, { locale })
Vue.use(VueRouter);

window.v = voca

import * as echarts from "echarts"
Vue.prototype.$echarts = echarts

// ras.getPublicKey()

// 创建一个路由对象用于管理页面的路由
const router = new VueRouter({
  mode: 'history',
  routes: routes
});


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')





// WEBPACK FOOTER //
// ./src/main.js